export const solutionsPageData = {
  hero: {
    badge: "Business Solutions",
    headline: "Solutions Built Around Your Business Goals",
    subtext: "From startup MVPs to enterprise transformation, we deliver technology solutions designed for your specific business context.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
    image: "https://readdy.ai/api/search-image?query=Abstract%20business%20solutions%20visualization%2C%20connected%20enterprise%20nodes%20and%20workflow%20diagrams%2C%20digital%20transformation%20concept%2C%20blue%20and%20purple%20gradient%20lighting%2C%20premium%20technology%20aesthetic%2C%20dark%20background%2C%20no%20text%2C%20no%20people&width=1400&height=800&seq=solutions-hero-1&orientation=landscape",
  },
  categories: [
    {
      id: "startup",
      title: "Startup Solutions",
      desc: "Build fast, iterate faster. We help startups launch MVPs and scale their products.",
      icon: "ri-rocket-line",
      color: "#f97316",
      items: ["MVP Development", "Startup Product Development", "Dedicated Developers", "SaaS Development", "Technical Consulting"],
      cta: "Explore Startup Solutions",
    },
    {
      id: "business",
      title: "Business Solutions",
      desc: "Custom software that automates processes, integrates systems and drives growth.",
      icon: "ri-building-4-line",
      color: "#2563EB",
      items: ["Custom Software", "Business Automation", "CRM & ERP", "Enterprise Applications", "Dashboards & Analytics", "System Integrations"],
      cta: "Explore Business Solutions",
    },
    {
      id: "enterprise",
      title: "Enterprise Solutions",
      desc: "Large-scale applications with security, compliance and integration at the core.",
      icon: "ri-bar-chart-box-line",
      color: "#7C3AED",
      items: ["Enterprise Applications", "API Ecosystems", "Cloud Modernization", "Legacy Modernization", "Security & Compliance"],
      cta: "Explore Enterprise Solutions",
    },
    {
      id: "saas",
      title: "SaaS Solutions",
      desc: "Multi-tenant platforms with billing, analytics and scalable architecture for product companies.",
      icon: "ri-cloud-line",
      color: "#6366f1",
      items: ["SaaS Development", "Product Engineering", "Dedicated Development Teams", "Technical Support", "White-label Platforms"],
      cta: "Explore SaaS Solutions",
    },
    {
      id: "ai",
      title: "AI Solutions",
      desc: "Integrate modern AI capabilities into your applications, workflows and SaaS products.",
      icon: "ri-bard-line",
      color: "#0ea5e9",
      items: ["AI Integration", "AI Assistants", "AI Chatbots", "Workflow Automation", "AI-powered Applications", "AI SaaS Features"],
      cta: "Explore AI Solutions",
    },
    {
      id: "modernization",
      title: "Legacy Modernization",
      desc: "Transform legacy systems into modern, cloud-native applications.",
      icon: "ri-refresh-line",
      color: "#10b981",
      items: ["Legacy PHP Migration", "Old Web Applications", "Database Modernization", "Laravel Migration", "Cloud Migration", "Performance Optimization"],
      cta: "Explore Modernization",
    },
    {
      id: "dedicated",
      title: "Dedicated Development Teams",
      desc: "Full teams working exclusively on your project with Laravel, Flutter, frontend and QA expertise.",
      icon: "ri-team-line",
      color: "#f59e0b",
      items: ["Laravel Developers", "Flutter Developers", "Frontend Developers", "Backend Developers", "QA Engineers", "Project Managers"],
      cta: "Explore Dedicated Teams",
    },
    {
      id: "transformation",
      title: "Digital Transformation",
      desc: "Modernize your business with cloud, automation and AI-powered digital products.",
      icon: "ri-magic-line",
      color: "#d946ef",
      items: ["Cloud Strategy", "Process Automation", "AI Integration", "Data Analytics", "API Ecosystems", "Modern Architecture"],
      cta: "Explore Digital Transformation",
    },
  ],
  cta: {
    heading: "Have a project in mind?",
    text: "Let's build something that scales.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
  },
};